module.exports = __webpack_public_path__ + "static/service-3-1-216a68638ae8e9e1deb48b5a8cd54624.png";